import React from "react";
import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Page from "src/components/Page";

import Header from "./Header";
import PromotionCreateForm from "./PromotionCreateForm";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },

  container: {
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 64,
      paddingRight: 64,
    },
  },
}));

function PromotionCreate() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Create Promotion">
      <Container maxWidth={false} className={classes.container}>
        <Header />

        <PromotionCreateForm />

      </Container>
    </Page>
  );
}

export default PromotionCreate;